import React, { useState, useEffect } from 'react';
import { Col, Divider, Menu, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import { Link, useParams } from 'react-router-dom';
import LoadingSpinner from '../../components/shared/components/LoadingSpinner';
import Title from 'antd/es/typography/Title';
import { getCommunityEvent } from '../../services/communityService';
import ActionHeader from '../../components/Common/ActionHeader';
import EditCommunityEvent from './components/EditCommunityEvent';
import DeleteWarningModal from '../../components/Common/DeleteWarningModal';

const CommunityEventPage = () => {
  const [communityEvent, setCommunityEvent] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const { id } = useParams();

  const actionMenu = (
    <Menu>
      <Menu.Item onClick={() => setIsEditModalVisible(true)}>
        Edit
      </Menu.Item>
      <Menu.Item onClick={() => setIsDeleteModalVisible(true)}>
        Delete
      </Menu.Item>
    </Menu>
  );

  const fetchData = async () => {
    setIsLoading(true);
    setStatus(null);
    await getCommunityEvent({ _id: id })
      .then((response) => {
        if (response?.data) {
          setCommunityEvent(response?.data);
        } else {
          throw Error('This community event does not exist!');
        }
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`
        });
      });
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData().then();
  }, [id]);

  return (
    <>
      {isLoading && <LoadingSpinner />}
      {!isLoading && communityEvent?.title && (
        <div>
          <ActionHeader
            title={'Community event: ' + communityEvent?.title}
            actionMenu={actionMenu}
          />
          <Divider />
          <section>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Event Id:</Col>
              <Col span={16}>
                <Text strong>{communityEvent?.eventId}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Title:</Col>
              <Col span={16}>
                <Text strong>{communityEvent?.title}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Description:</Col>
              <Col span={16}>
                <Text strong>{communityEvent?.description}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Start Time:</Col>
              <Col span={16}>
                <Text strong>{communityEvent?.startTime}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>End Time:</Col>
              <Col span={16}>
                <Text strong>{communityEvent?.endTime}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Live link:</Col>
              <Col span={16}>
                <Text strong>
                  <a
                    href={communityEvent?.liveLink}
                    target="_blank"
                    rel="noopener noreferrer">
                    {communityEvent?.liveLink}
                  </a>
                </Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Recording link:</Col>
              <Col span={16}>
                <Text strong>
                  <a
                    href={communityEvent?.recordingLink}
                    target="_blank"
                    rel="noopener noreferrer">
                    {communityEvent?.recordingLink}
                  </a>
                </Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Is Active:</Col>
              <Col span={16}>
                <Text strong>
                  {communityEvent?.isActive ? 'true' : 'false'}
                </Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Status:</Col>
              <Col span={16}>
                <Text strong>{communityEvent?.status}</Text>
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Host:</Col>
              <Col span={16}>
                <Text strong>
                  {communityEvent?.host?.firstName} -{' '}
                  {communityEvent?.host?.lastName}
                </Text>
                <img
                  alt="profileImg"
                  width={50}
                  height={50}
                  style={{ borderRadius: '100%', marginLeft: 16 }}
                  src={communityEvent?.host?.profileImage}
                />
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Card Image:</Col>
              <Col span={16}>
                <img
                  alt="profileImg"
                  width={50}
                  height={50}
                  src={communityEvent?.cardImgData?.mobileImgData?.src}
                />
              </Col>
            </Row>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col span={8}>Communities:</Col>
              <Col span={16}>
                <Text>
                  {communityEvent?.communities?.length > 0 &&
                    communityEvent?.communities?.map((comm, index) => (
                      <span key={index} style={{ marginRight: 8 }}>
                        <Link to={`community/${comm}`}>{comm}</Link>
                      </span>
                    ))}
                </Text>
              </Col>
            </Row>
          </section>
        </div>
      )}
      <EditCommunityEvent
        communityEvent={communityEvent}
        onCancelModal={() => setIsEditModalVisible(false)}
        isOpen={isEditModalVisible}
      />
      <DeleteWarningModal
        isVisible={isDeleteModalVisible}
        setIsVisible={setIsDeleteModalVisible}
        deleteLink={`${process.env.REACT_APP_BACKEND_URL}/community/event/${id}`}
        params={{}}
      />
      {status?.error && (
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <Title>{status?.message}</Title>
        </div>
      )}
    </>
  );
};

export default CommunityEventPage;
